// filepath: /home/p3rry/Downloads/Tamohar-02/src/api/config.js
const API_BASE_URL = "https://tamohar-02.onrender.com";

export default API_BASE_URL;
